<template>
  <div class="dept">
    <el-input
      class="search-dept"
      prefix-icon="el-icon-search"
      v-model.trim="departmentName"
      @change="searchDepLocal"
      size="small"
      placeholder="部门名称"
    />
    <el-tree
      class="tree-dept"
      ref="tree"
      :props="props"
      :data="deptTreeData"
      node-key="id"
      :expand-on-click-node="true"
      :filter-node-method="filterNode"
      highlight-current
      @node-click="nodeClick"
      show-checkbox
      @check="handleCheck"
      lazy
      :load="loadNode"
    >
      <span  class="custom-tree-node" slot-scope="{ node, data }">
        <template v-if="showTooltip">
          <el-tooltip v-if="isSearch" class="item" effect="dark" :content="data.fullName" placement="top-start">
            <span class="ellipsis--l1">{{ data.simpleName || node.label }}</span>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" :content="node.label" placement="top-start">
            <span class="ellipsis--l1">{{ node.label }}</span>
          </el-tooltip>
        </template>
        <span v-else class="ellipsis--l1">{{ node.label }}</span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import { throttle } from "@/utils/common.js";
export default {
  props: {
    defaultId: {
      type: String,
      default: "",
    },
    loadNode: {
      type: Function,
      default: null,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    props: {
      type: Object,
      default: function() {
        return {
          label: "deptName",
          isLeaf: "isLeaf",
        };
      },
    },
    deptTreeData: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      departmentName: "",
      isSearch: false,
    };
  },
  watch: {
    defaultId: {
      handler(val) {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(val);
        });
      },
    },
  },
  updated() {
    let doms = document.getElementsByClassName("el-tree-node__label");
    for (let i = 0; i < doms.length; i++) {
      const dom = doms[i];
      dom.title = dom.innerText;
    }
  },
  methods: {
    nodeClick(data) {
      // this.$emit("select", { deptId: data.id });
    },
    handleCheck(data) {
      let temp = this.$refs.tree.getCheckedNodes();
      this.$emit("select", {
        deptId: temp.map((x) => x.deptLevelCode),
      });
    },
    handleCheckChange: throttle(function() {
      let temp = this.$refs.tree.getCheckedNodes();
      this.$emit("select", {
        deptId: temp.map((x) => x.deptLevelCode),
      });
    }, 500),
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    searchDepLocal(val) {
      this.isSearch = val && val.length > 0      
      this.$emit('searchDep', val)
    },
  },
};
</script>

<style lang="scss" scoped>
.dept {
  .search-dept {
    font-size: 12px;
  }
  /deep/ .el-input__inner::placeholder {
    font-size: 12px;
  }
  .tree-dept {
    margin-top: 10px;
    background-color: #f4f8fb;
    color: #51627d;
    font-size: 12px;
    max-height: 540px;
    overflow: auto;
  }
}
/deep/ .el-tree-node__content {
  height: auto;
}
</style>
